import { render, staticRenderFns } from "./RulesFilter.vue?vue&type=template&id=523852ad&scoped=true"
import script from "./RulesFilter.vue?vue&type=script&lang=js"
export * from "./RulesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523852ad",
  null
  
)

export default component.exports